import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header className="fixed top-0 w-full z-40 bg-white/85 backdrop-blur-xl border-b border-[#e5e5e5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center"
          data-testid="brand-logo"
        >
          <span className="font-brand text-3xl leading-none">K-Walk</span>
        </Link>

        <nav className="hidden md:flex gap-10 text-sm font-medium">
          <Link to="/shop" className="hover:opacity-60 transition-opacity" data-testid="nav-shop">
            Shop
          </Link>
          <Link
            to="/shop?category=loafers"
            className="hover:opacity-60 transition-opacity"
            data-testid="nav-loafers"
          >
            Loafers
          </Link>
          <Link
            to="/shop?category=slip-ons"
            className="hover:opacity-60 transition-opacity"
            data-testid="nav-slipons"
          >
            Slip-Ons
          </Link>
          <Link
            to="/shop?category=chelsea"
            className="hover:opacity-60 transition-opacity"
            data-testid="nav-chelsea"
          >
            Chelsea
          </Link>
          <Link
            to="/shop?category=derby"
            className="hover:opacity-60 transition-opacity"
            data-testid="nav-derby"
          >
            Derby
          </Link>
          <Link
            to="/shop?category=monk"
            className="hover:opacity-60 transition-opacity"
            data-testid="nav-monk"
          >
            Monk
          </Link>
          <Link
            to="/shop?category=heritage"
            className="hover:opacity-60 transition-opacity"
            data-testid="nav-heritage"
          >
            Heritage
          </Link>
          <Link
            to="/shop?category=wedding"
            className="hover:opacity-60 transition-opacity text-[#8c7a6b] font-semibold"
            data-testid="nav-wedding"
          >
            Wedding
          </Link>
        </nav>

        <div className="flex items-center gap-5">
          {user ? (
            <div className="hidden md:flex items-center gap-4">
              {user.role === "admin" && (
                <Link
                  to="/admin"
                  className="text-xs uppercase tracking-widest hover:opacity-60"
                  data-testid="nav-admin"
                >
                  Admin
                </Link>
              )}
              <Link to="/account" className="hover:opacity-60" data-testid="nav-account">
                <User size={18} />
              </Link>
              <button
                onClick={async () => {
                  await logout();
                  nav("/");
                }}
                className="hover:opacity-60"
                data-testid="nav-logout"
                aria-label="Logout"
              >
                <LogOut size={18} />
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              className="hidden md:block text-sm font-medium hover:opacity-60"
              data-testid="nav-login"
            >
              Sign in
            </Link>
          )}

          <button
            onClick={() => setOpen(true)}
            className="relative hover:opacity-60"
            data-testid="nav-cart"
            aria-label="Open cart"
          >
            <ShoppingBag size={20} />
            {count > 0 && (
              <span
                className="absolute -top-2 -right-2 bg-[#111] text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center"
                data-testid="cart-count"
              >
                {count}
              </span>
            )}
          </button>

          <button
            className="md:hidden"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-[#e5e5e5] bg-white px-6 py-6 flex flex-col gap-5 text-sm">
          <Link to="/shop" onClick={() => setMenuOpen(false)}>
            Shop
          </Link>
          <Link to="/shop?category=loafers" onClick={() => setMenuOpen(false)}>
            Loafers
          </Link>
          <Link to="/shop?category=slip-ons" onClick={() => setMenuOpen(false)}>
            Slip-Ons
          </Link>
          <Link to="/shop?category=chelsea" onClick={() => setMenuOpen(false)}>
            Chelsea
          </Link>
          <Link to="/shop?category=derby" onClick={() => setMenuOpen(false)}>
            Derby
          </Link>
          <Link to="/shop?category=monk" onClick={() => setMenuOpen(false)}>
            Monk
          </Link>
          <Link to="/shop?category=heritage" onClick={() => setMenuOpen(false)}>
            Heritage
          </Link>
          <Link to="/shop?category=wedding" onClick={() => setMenuOpen(false)}>
            Wedding
          </Link>
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" onClick={() => setMenuOpen(false)}>
                  Admin
                </Link>
              )}
              <Link to="/account" onClick={() => setMenuOpen(false)}>
                Account
              </Link>
              <button
                onClick={async () => {
                  await logout();
                  setMenuOpen(false);
                  nav("/");
                }}
                className="text-left"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" onClick={() => setMenuOpen(false)}>
              Sign in
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
